import angular from 'angular';
import modalConfirmation from '../shared/components/modal-response/modal-response.view.html';
let inject = [
  '$scope',
  'TemplatesService',
  '$state',
  '$rootScope',
  'SharedService',
  '$uibModal',
  '$timeout',
  'Pagination',
  'SessionService',
  '$window'
];

class TemplatesController{
  constructor ($scope, TemplatesService, $state, $rootScope, SharedService, $uibModal, $timeout, Pagination, SessionService, $window) {
    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.$uibModal = $uibModal;
    this.TemplatesService = TemplatesService;
    this.Pagination = Pagination;
    this.SharedService = SharedService;
    this.SessionService =SessionService;
    this.$window = $window;
  
    /**
     Text for searching orders
     @property searchText
     @type String
     @default ''
     */
    this.searchText = '';
  
    /**
     Sort type by order attribute
     @property sortType
     @type String
     @default 'name'
     */
    this.sortType = 'fecha_creacion';
  
    /**
     Orders sort order. Use true for reverse order
     @property sortReverse
     @type boolean
     @default false
     */
    this.sortReverse = true;
  
    this.userCartTemplates = [];
    this.loadingUserCartTemplates = false;
    this.loadedUserCartTemplates = false;
    this.errorloadingUserCartTemplates = false;
    this.itemsPerPage = 10;
  }

  $onInit(){
    this.getUserCartTemplates();
  }
  
  deleteCartTemplate (cartTemplate) {
    cartTemplate.loading = true;
    cartTemplate.response = {};
    
    let globals = this.shCtrl.globals;
    let userId = '';
    try {
      userId = globals.currentUser.userId;
    }
    catch (e) {
    }
    
    let sellerId = '';
    try {
      sellerId = globals.currentUser.sellerId;
    }
    catch (e) {
    }
    this.TemplatesService.deleteCartTemplate({
      'cartTemplateId': cartTemplate.id,
      'userId': userId,
      'sellerId': sellerId}).then(response => {
      cartTemplate.loading = false;
      cartTemplate.response = response;
      
      if (!response.error) {
        this.$timeout(() => {
          this.$state.reload()
        }, 1000);
      }
    }).catch(reason => {
      cartTemplate.loading = false;
      cartTemplate.response.error = true;
      cartTemplate.response.message = 'Ha ocurrido un error interno. Por favor contacte al administrador del sistema.';
    });
  }
  
  getUserCartTemplates () {
    
    let globals = this.shCtrl.globals;
    let userId = '';
    try {
      userId = globals.currentUser.userId;
    }
    catch (e) {
    }
    
    let sellerId = '';
    try {
      sellerId = globals.currentUser.sellerId;
    }
    catch (e) {
    }
    
    this.loadingUserCartTemplates = true;
    this.loadedUserCartTemplates = false;
    this.errorloadingUserCartTemplates = false;
    
    this.TemplatesService.getUserCartTemplates({'userId': userId, 'sellerId': sellerId}).then(response => {
      this.loadingUserCartTemplates = false;
      this.loadedUserCartTemplates = true;
      this.errorloadingUserCartTemplates = false;
  
      // this.pagination = this.Pagination.getNew(40);
      this.pagination = this.Pagination.getNew(this.itemsPerPage);
      this.userCartTemplates = response.data;
  
      if (this.userCartTemplates.templates.length > 0) {
        this.pagination.numPages = Math.ceil(this.userCartTemplates.templates.length / this.pagination.perPage);
      }
    }).catch(reason => {
      this.loadingUserCartTemplates = false;
      this.loadedUserCartTemplates = true;
      this.errorloadingUserCartTemplates = true;
    });
  }
  
  loadCartTemplateToCurrentCart(cartTemplate) {
    cartTemplate.duplicate = {};
    
    cartTemplate.duplicate.duplicating = true;
    cartTemplate.duplicate.duplicated = false;
    cartTemplate.duplicate.message = '';
    
    let cartTemplateId = cartTemplate.id;
    let cartId = this.SessionService.get('cartId') || '';
    this.TemplatesService.duplicateCartTemplate({'cartTemplateId': cartTemplateId, 'cartId': cartId}).then(response => {
      this.$timeout(() => {
        if (!response.error) {
          cartTemplate.duplicate.duplicating = false;
          cartTemplate.duplicate.duplicated = true;
      
          cartTemplate.duplicate.error = false;
          cartTemplate.duplicate.message = response.message;
      
          this.SessionService.put('cartId', response.cartId);
          this.$state.go('home.cart');
        }
        else {
          cartTemplate.duplicate.duplicating = false;
          cartTemplate.duplicate.duplicated = false;
      
          cartTemplate.duplicate.error = true;
          cartTemplate.duplicate.message = response.message;
        }
      }, 1000);
    }).catch(reason => {
      cartTemplate.duplicate.duplicating = false;
      cartTemplate.duplicate.duplicated = false;
  
      cartTemplate.duplicate.error = true;
      cartTemplate.duplicate.message = 'Ha ocurrido un error al duplicar el pedido.';
    });
  }
  
  setCurrentCartTemplate (template) {
    this.currentCartTemplate = template;
  }

  messageResponse (options, callAcept, callback, callCancel, callbackCancel) {
    let modalInstance = this.$uibModal.open({
      animation: true,
      template: modalConfirmation,
      controller : 'ModalResponseController',
      controllerAs : 'mdCtrl',
      size: options.size,
      resolve : {
        modalOptions : () => options
      }
    });
    modalInstance.result.then(() => {
      if(callAcept) {
        callback();
      }
    }).catch(reason => {
      if(callCancel) {
        callbackCancel();
      }
    });
  }
  
  setPagination (itemsPerPage) {
    this.itemsPerPage = itemsPerPage;
    this.pagination = this.Pagination.getNew(this.itemsPerPage);
    this.pagination.numPages = Math.ceil(this.userCartTemplates.templates.length / this.pagination.perPage);
  }
}

TemplatesController.$inject = inject;

export default TemplatesController;




// WEBPACK FOOTER //
// ./www/components/templates/templates.controller.js